<template>
    <div class="bar-follow-page">
        <van-nav-bar fixed @click-left="onClickLeft" style="background:#409eff;height:36px;color:white">
            <template #title>
                <span style="font-weight:600;font-size:16px;color:#fff;line-height:36px;">{{v_title}}</span>
            </template>
            <template #left>
                <div style="font-weight:600;font-size:14px;color:#fff;padding-left:3px;line-height:36px;"><i class="iconfont icon-shangyiye" style="margin-right:5px"></i>返回</div>
            </template>
        </van-nav-bar>
        <div class="query-tabs" role="tablist" aria-label="查询范围">
            <button type="button" role="tab" :class="{ 'is-active': v_tabName==='first' }"
                :aria-selected="v_tabName==='first' ? 'true' : 'false'" :disabled="materialPrintBusy || isSearching"
                @click="itemClick('first')">实时库存</button>
            <button type="button" role="tab" :class="{ 'is-active': v_tabName==='second' }"
                :aria-selected="v_tabName==='second' ? 'true' : 'false'" :disabled="materialPrintBusy || isSearching"
                @click="itemClick('second')">原材料</button>
        </div>
        <div style="width:100%;background:#808695;display:flex;height:40px; " >
            <input type="text" @keydown.enter="onSearch" ref="refscan" placeholder="PDA 扫描区" v-model="v_scan" style="width:80%;border:1px solid #fcc;height:28px;margin-top:8px;margin-left:5px"  >
            <div @click="onScan" style="width:30px;height:28px;background:#FFFFFF;border-radius:3px;display:flex;margin-top:6px;margin-left:8px; cursor:pointer; ">
                <van-icon name="scan" size="14" color="#235EFF" style="margin-top:3px;margin-left:8px"/>
            </div>
        </div>
        <!-- <div class="one-toolbar" style="display:flex;justify-content:space-between">
            <div class="oneRow" style="font-size:14px;height:25px">基本信息</div>  
        </div> -->
        <div class="rounded-corner"  >
            <div style="display:flex;font-size:14px;font-weight:600;color:black;line-height:30px" class="mul-div">
                <div style="width:50%">物料编码：{{v_row.MATNO}} </div>
                <div style="width:50% ">物料类别：{{v_row.MATTYNM}}</div>
            </div>  
            <div style="display:flex;width:100%">
                <div style="display:flex;font-size:13px; font-weight:600;line-height:30px">
                    <div style="width:75px;color:black; font-weight:600; ">物料名称：</div>
                    <div class="mul-div2">  {{v_row.MATNM}}  </div>  
                </div>         
            </div>  
            <div style="display:flex;width:100%">
                <div style="display:flex;font-size:13px; font-weight:600;line-height:30px">
                    <div style="width:75px;color:black; font-weight:600; ">规格描述：</div>
                    <div class="mul-div2">  {{v_row.MATDESC}}  </div>  
                </div>         
            </div>
            <div v-if="v_row.MATNO" class="material-picture-section">
                <p v-if="materialImageLoading" class="material-image-status" role="status">正在读取物料图片…</p>
                <div v-else-if="materialImageError" class="material-image-status" role="alert">
                    <span>物料图片读取失败</span>
                    <button type="button" @click="loadMaterialImages()">重新读取</button>
                </div>
                <p v-else-if="!materialImages.length" class="material-image-status">暂无物料图片</p>
                <div v-if="materialImages.length" class="material-images" role="group" :aria-label="v_row.MATNO + '图片'">
                    <button v-for="(src, index) in materialImages" :key="src" type="button" class="material-thumbnail"
                        :aria-label="'查看' + v_row.MATNO + '第' + (index + 1) + '张图片'"
                        @click="previewMaterialImages(index, $event)">
                        <van-image :src="src" fit="contain" :alt="(v_row.MATNM || v_row.MATNO) + '图片 ' + (index + 1)">
                            <template slot="error"><span class="material-image-error">加载失败</span></template>
                        </van-image>
                    </button>
                </div>
            </div>
            <div v-if="v_tabName==='second' && v_row.MATNO" style="display:flex;justify-content:flex-end;margin-top:8px">
                <MaterialLabelPrint
                    :material="v_row"
                    :copies-in-preview="true"
                    :disabled="materialPrintBusy || isSearching"
                    @busy="materialPrintBusy = $event"
                />
            </div>
        </div>
        <div v-if="v_tabName==='first'" class="one-toolbar" style="display:flex;justify-content:space-between">
            <div class="oneRow" style="font-size:14px;height:25px">库存信息</div>  
        </div>
        <div v-if="v_tabName==='first'" class="stock-scroll">
            <div v-for="(item,index) in dtlData" :key="index" class="rounded-corner stock-group" style="display:flex;flex-direction:column;justify-content:space-between">
                <div class="stock-header">
                    <div class="stock-warehouse">仓库名称：{{item.STKNM}}</div>
                    <div class="stock-quantity-actions">
                        <span class="stock-quantity">库存数量：{{item.QTY}} {{item.UNITNM}}</span>
                        <MaterialLabelPrint
                            :material="item"
                            :copies-in-preview="true"
                            :disabled="materialPrintBusy"
                            @busy="materialPrintBusy = $event"
                        />
                    </div>
                </div>
                <div class="stock-location">仓位：{{item.PLCNM || '未设置'}}</div>
                <time-line
                    :materialCode="item['MATNO']"
                    :nodes="item.LOGARR"
                />     
            </div>
        </div>
 
        <!-- 返回顶部 -->
        <div class="go_top_btn" v-show="topShow" @click="goTop">
            <van-icon name="arrow-up" size="26rem" color="#ff6700" />
        </div>
        <!-- 扫码组件 -->
        <ScanCode
            :visible.sync="showScan"
            @success="handleScan"
        />
        <van-image-preview v-model="imagePreviewOpen" :images="previewImages" :start-position="previewImageIndex"
            :close-on-popstate="false" get-container="body" class-name="trace-material-preview"
            role="dialog" aria-label="物料图片预览" aria-modal="true" @close="closeMaterialPreview"
            @keydown.esc.native.stop.prevent="closeMaterialPreview">
            <template slot="cover">
                <button ref="materialPreviewClose" type="button" class="material-preview-close" aria-label="关闭图片预览"
                    @click.stop="closeMaterialPreview">关闭</button>
            </template>
        </van-image-preview>
    </div>
</template>

<script>
import TimeLine from '@/components/timeline.vue'
import {getDate,getDate2,getRecNum} from '@/api/tools'
import ScanCode from "@/components/common/ScanCode.vue"
import MaterialLabelPrint from '@/components/stockCheck/MaterialLabelPrint.vue'
import { getMaterialImageUrls, materialImagePath } from '@/api/materialImages'
 
export default {
  name: "poship_barcode",
  data() {
    return {      
      t_loading:false,
      showScan:false,
      finished:false,  
      d_isfinish:false,
 
      currentDate:new Date(),
      minDate:new Date(new Date().getTime()-30*24*60*60*1000),
      v_pono:'',
      actions:[],

      v_scan:'',
      v_tabName:'first',
      previewUrl:'',
      pendingLabel:null,
 
      scroll: 0,
      topShow: false,
 
      itemData:[],
      poArrList:[],
      currentPage: 1,
      currPage: 1,
      v_total:0,
      rowSize:10,
      v_usernm :this.$cookies.get('v_usernm' ), //用户名称 
      v_username :this.$cookies.get('v_telno' ), //用户名称 
      pageSize:25,
      v_corpid:this.$cookies.get('v_corpid' ),
      dtlData:[],
      materialPrintBusy:false,
      isSearching:false,
      materialImageUrls:null,
      materialImageLoading:false,
      materialImageError:'',
      imagePreviewOpen:false,
      previewImages:[],
      previewImageIndex:0,
      tabData:[],
 
      v_title:'',
 
      v_row:{},
      cancelBool:false, //改他人
      v_form:{},
      addBool:false, //新增 权限
      editBool:false, //编辑权限
      cfmBool:false,
      v_flag:false,
  
      v_vat:'',
      v_commit:false,
      error:'',
      listArr:[],
 
    };
  },
  components: {
    ScanCode,
    TimeLine,
    MaterialLabelPrint
 
  },
  created() {
    this._imageSequence = 0
  },
  mounted() { 
    //窗口滚动
    window.addEventListener("scroll", this.windowScroll);
    this.initData()  //初始化
    this.$refs.refscan.focus()
 
  },
  beforeDestroy() {
    this._imageSequence++
    window.removeEventListener('scroll', this.windowScroll)
  },
  computed: {
    materialImages() {
      if (this.materialImageUrls !== null) return this.materialImageUrls
      const image = materialImagePath(this.v_row.IMGPATH)
      return image ? [image] : []
    }
  },
  methods: {
    itemClick(v_tabName){
        if (this.materialPrintBusy || this.isSearching || this.v_tabName===v_tabName) return
        this.v_tabName =v_tabName
        this.v_scan =''
        this.v_row ={}
        this.dtlData =[]
        this.showScan =false
        this.resetMaterialImages()
    },
    async queryMaterialImageRows(data, url = 'xuper_auth/getBaseData') {
      const response = await this.$axios({ method: 'post', url, data })
      if (response.code != '200') {
        throw new Error(typeof response.result === 'string' && response.result ? response.result : '物料图片读取失败')
      }
      if (!Array.isArray(response.result)) throw new Error('查询返回格式异常，请重试')
      return response.result
    },
    async loadMaterialImages(row = this.v_row) {
      const sequence = ++this._imageSequence
      this.materialImageLoading = true
      this.materialImageError = ''
      try {
        const images = await getMaterialImageUrls(row, this.v_corpid, (data, url) => this.queryMaterialImageRows(data, url))
        if (sequence === this._imageSequence) this.materialImageUrls = images
      } catch (error) {
        if (sequence === this._imageSequence) this.materialImageError = error.message || '请重试'
      } finally {
        if (sequence === this._imageSequence) this.materialImageLoading = false
      }
    },
    resetMaterialImages() {
      this._imageSequence++
      this.materialImageUrls = null
      this.materialImageLoading = false
      this.materialImageError = ''
      this.imagePreviewOpen = false
      this.previewImages = []
      this._materialPreviewTrigger = null
    },
    previewMaterialImages(index, event) {
      if (!Number.isInteger(index) || index < 0 || index >= this.materialImages.length) return
      this.previewImages = this.materialImages
      this.previewImageIndex = index
      this._materialPreviewTrigger = event && event.currentTarget
      this.imagePreviewOpen = true
      this.$nextTick(() => { if (this.$refs.materialPreviewClose) this.$refs.materialPreviewClose.focus() })
    },
    closeMaterialPreview() {
      this.imagePreviewOpen = false
      const trigger = this._materialPreviewTrigger
      this._materialPreviewTrigger = null
      if (trigger && trigger.isConnected) this.$nextTick(() => trigger.focus())
    },
  
    // 扫码成功回调
    handleScan(code) {
      console.log("扫码结果", code)
      this.showScan = false
      
      // 扫码返回的是订单ID，根据ID查询订单
      this.v_scan = code
      this.onSearch()
    },
 
    repBtn(item,val){
        if (item['SORTBY']){
            //
        }else{
            this.$dialog.alert({ title: '提示', message: '还未生成匹号，请先保存', theme: 'round-button',}) 
        }
    },
 
    async getDtlList(v_idseq){
        const loadingToast = this.$toast.loading({
            message: '加载中...',
            forbidClick: true,    // 禁止背景点击
            duration: 0,          // 持续展示，不自动关闭
            loadingType: 'spinner' // loading 样式
        })
        try {
            await this.$axios({
                method: 'post',
                url:  'xuper_auth/getBaseData',
                data: {p_key: 'idseq',p_value:v_idseq,p_table:'V_POREQDTL_LOCK',p_cond:' order by matno ' },
            }).then(res=>{
                if (res.code =='200') {
                    this.itemData =res.result
       
                }else{
                    this.$dialog.alert({ title: '提示', message: res.result, theme: 'round-button',}) 
                }            
            })
        }finally {
            loadingToast.clear()
        }
    },
 
    // 扫码
    onScan() {
      this.showScan = true
    }, 
    async onSearch(){
        if (this.materialPrintBusy || this.isSearching) return
        let v_scan =String(this.v_scan || '').trim()
        if (v_scan==''){
            this.$dialog.alert({ title: '提示', message: '请先扫描条码', theme: 'round-button',}) 
            return
        }
        this.resetMaterialImages()
        this.v_row = {}
        this.dtlData =[]
        this.isSearching =true
        const loadingToast = this.$toast.loading({
            message: '加载中...',
            forbidClick: true,    // 禁止背景点击
            duration: 0,          // 持续展示，不自动关闭
            loadingType: 'spinner' // loading 样式
        })
        try {
            let v_param ={p_key:'matno',p_value:v_scan,p_key2:'corpid',p_value2:this.v_corpid,p_cond:' order by stkno desc',p_table:'V_IC_STKLOG' }
            if (this.v_tabName==='second'){
                v_param ={p_key:'idno',p_value:v_scan,p_key2:'corpid',p_value2:this.v_corpid,p_key3:'modelno',p_value3:'MAT',p_table:'V_BS_MATQRY' }
            }
            await this.$axios({  //p_key:'idseq',p_value:v_seq,
                method: 'post',
                url:  'xuper_auth/getBaseData',
                data: v_param,
            }).then(res=>{
                if (res.code =='200') {
                    if (!Array.isArray(res.result)) throw new Error('查询返回格式异常，请重试')
                    let v_data =res.result
                    this.v_scan=''
                    if (!v_data.length){
                        this.$dialog.alert({ title: '提示', message: this.v_tabName==='second' ? '未找到该原材料' : '未找到该物料的实时库存', theme: 'round-button',})
                        return
                    }
                    // 原材料主档使用 IDNO、IDSEQ，适配现有资料和图片展示字段。
                    this.v_row =this.v_tabName==='second'
                        ? {...v_data[0],MATNO:v_data[0].IDNO,MATIDSEQ:v_data[0].IDSEQ}
                        : v_data[0]
                    this.loadMaterialImages(this.v_row)
                    if (this.v_tabName==='second') return
                    let v_promises= v_data.map(item => {
                        return this.$axios({  //p_key:'idseq',p_value:v_seq,
                            method: 'post',
                            url:  'xuper_auth/getBaseData',
                            data: {p_key:'stkno',p_value:item['STKNO'],p_key2:'matno',p_value2:item['MATNO'],p_cond:' and stfg=\'Y\' order by CHKdttm desc,lstseq',p_table:'V_TRANS_OUT' },
                        }).then(res=>{
                            if (res.code != '200') throw new Error(res.result || '库存轨迹加载失败')
                            // 保留接口返回的 MATDESC、PLCNM、STKNO 等字段供当前库存标签使用。
                            return {
                                ...item,
                                LOGARR:res.result || []
                            }
                        })
                    })
                    return Promise.all(v_promises).then(rows=>{
                        this.dtlData =rows
                    }) 
                    
                }else {
                    this.$dialog.alert({ title: '提示', message: res.result, theme: 'round-button',}) 
                }
            })
        }catch(err){
            this.$dialog.alert({ title:this.v_tabName==='second' ? '原材料信息加载失败' : '库存信息加载失败', message:err.message || '请重试' })
        }finally {
            loadingToast.clear()
            this.isSearching =false
        }
    },
 
    //初始化
    initData(){
        this.$axios({  //p_key:'idseq',p_value:v_seq,
            method: 'post',
            url:  'xuper_auth/getBaseData',
            data: {p_key:'isqry',p_value:'M',p_key2:'frmurl' ,p_value2:this.$route.query.path,p_table:'V_Sys_form' },
        }).then(res=>{
            if (res.result.length>0){
                this.v_title =res.result[0]['CFRMNM']    
              
            }else{
                this.$dialog.alert({ title: '提示', message: '没有找到记录'+ res.result, theme: 'round-button',}) 
            }
        })
  
        //用户权限
        this.$axios({  //p_key:'idseq',p_value:v_seq,
            method: 'post',
            url:  'xuper_auth/getBaseData',
            data: {p_key:'userno',p_value:this.v_username,p_key2:'frmidseq',p_value2:'424704', p_table:'v_sys_user_priv' },
        }).then(res=>{
            let row =res.result[0]
            if (row.ISADD==='N'){ //新增
                this.addBool=true
            }if (row.ISUPD==='N'){ //修改
                this.editBool=true
            }if (row.ISCFM==='N'){ //修改
                this.cfmBool=true
            }if (row.ISCANCEL==='N'){ //改他人
                this.cancelBool=true
            }   
        })
  
    },
 
    //返回
    onClickLeft(){
        this.$router.push({ 
            path: '/features' ,//url指的是跳转的路径名，需要在router里面配置
        })
    }, 
 
    windowScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.scroll > 300 ? (this.topShow = true) : (this.topShow = false);
    },
    //返回顶部
    goTop() {
      let timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.topShow = false;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
 
 
  },
  
};
</script>
<style lang="scss" scoped>
    .bar-follow-page {
        display: flex;
        flex-direction: column;
        height: 100vh;
        height: 100dvh;
        overflow: hidden;
        > :not(.stock-scroll) { flex-shrink: 0; }
    }
    .stock-scroll {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        margin-top: 2px;
    }
    .query-tabs {
        display: flex;
        margin-top: 36px;
        background: #fff;
        button {
            position: relative;
            flex: 1;
            height: 38px;
            padding: 0;
            border: 0;
            background: transparent;
            color: #666;
            font: inherit;
            font-size: 14px;
            cursor: pointer;
            &.is-active {
                color: #235eff;
                font-weight: 600;
                &::after {
                    position: absolute;
                    right: 25%;
                    bottom: 0;
                    left: 25%;
                    height: 2px;
                    background: #235eff;
                    content: '';
                }
            }
            &:disabled { color: #999; cursor: default; }
        }
    }
    .material-image-status {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 6px 0 0;
        color: #666;
        font-size: 12px;
        line-height: 24px;
        button {
            min-width: 48px;
            height: 32px;
            padding: 0 4px;
            border: 0;
            background: transparent;
            color: #235eff;
        }
    }
    .material-images {
        display: flex;
        gap: 8px;
        overflow-x: auto;
        margin-top: 8px;
        padding: 2px 0;
    }
    .material-thumbnail {
        flex: 0 0 64px;
        width: 64px;
        height: 64px;
        padding: 0;
        overflow: hidden;
        border: 1px solid #ebedf0;
        border-radius: 4px;
        background: #f7f8fa;
        cursor: pointer;
        ::v-deep .van-image { width: 100%; height: 100%; }
        &:focus-visible { outline: 2px solid #235eff; outline-offset: -2px; }
    }
    .material-image-error { font-size: 12px; }
    .material-preview-close {
        position: fixed;
        top: calc(12px + env(safe-area-inset-top));
        right: 12px;
        z-index: 1;
        min-width: 48px;
        height: 36px;
        padding: 0 12px;
        border: 0;
        border-radius: 18px;
        background: rgba(0, 0, 0, .5);
        color: #fff;
        font-size: 14px;
    }
    .stock-header {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px 12px;
        padding: 4px;
        background: #f7f8f9;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        color: #000;
    }
    .stock-warehouse {
        flex: 1 1 180px;
        min-width: 0;
        overflow-wrap: anywhere;
    }
    .stock-quantity-actions {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: auto;
    }
    .stock-quantity { white-space: nowrap; }
    .stock-location {
        padding: 4px;
        font-size: 13px;
        line-height: 22px;
        color: #666;
        overflow-wrap: anywhere;
    }
    .custom-btn {
        padding: 0 5px !important;
    }
  .scan{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      .scan-box{
        width: 100%;
      }
      .close-scan{
        position: absolute;
        top: 20px;
        right: 20px;
        svg{
          width: 40px;
          height: 40px;
        }
      }
    }
 .go_top_btn {
    width: 50px;
    height: 50px;
    line-height: 50px;
    padding-top: 6px;
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid #dcdcdc;
    box-shadow: 3px 3px 3px #888;
    text-align: center;
    position: fixed;
    right: 20px;
    bottom: 50px;
    cursor: pointer;
    * {
        cursor: pointer;
    }
    }
 .imgcss{
    width: 90%   ;
    line-height:30px;
    text-overflow:ellipsis; /*对超出容器的部分强制截取，高度不确定则换行*/
    overflow:hidden; /*显示省略符号来代表被修剪的文本。*/
    white-space:nowrap; //禁止换行,文本溢出显示省略号，要显示全内容在DIV上增加title属性
  }
  .img-css{
    width: 100%;
    height:100px;
    margin-left:5px;
    margin-right:5px;
 
  }
 .mul-div{
      text-overflow:ellipsis; /*对超出容器的部分强制截取，高度不确定则换行*/
      overflow:hidden; /*显示省略符号来代表被修剪的文本。*/
      white-space:nowrap; //禁止换行,文本溢出显示省略号，要显示全内容在DIV上增加title属性
  }
  .mul-div2{
        width:calc(100% - 75px);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        
        word-break: break-word;
    }
  .rounded-corner {
    border-radius: 6px; /* 设置圆角的半径为10像素 */
    background-color: #fFF; /* 背景颜色 */
    padding: 5px; /* 内边距 */
    margin: 5px; /* 外边距 */
    min-height:35px;
    box-shadow: 2px 2px 4px #ddd; /* 盒子阴影效果 */
  }
  .div-corner {
    border-radius: 5px; /* 设置圆角的半径为10像素 */
    background-color: #fFF; /* 背景颜色 */
    padding: 5px; /* 内边距 */
    margin: 5px; /* 外边距 */
    min-height:65px;
    box-shadow: 2px 2px 4px #ddd; /* 盒子阴影效果 */
  }
  .row-corner {
    border-radius: 5px; /* 设置圆角的半径为10像素 */
    background-color: #fFF; /* 背景颜色 */
    padding: 5px; /* 内边距 */
    margin: 5px; /* 外边距 */
    height:132px;
    box-shadow: 2px 2px 4px #ddd; /* 盒子阴影效果 */
  }
    
</style>
<style lang="less">
    .my-field .van-field {
      height: 30px !important; /* 修改为你想要的高度 */
      line-height: 30px !important; /* 确保文本垂直居中 */
      font-size:13px;
      padding-left:1px;
    }
 
    .field-select-button.van-button {
        min-width: 28px;
        height: 24px;
        padding: 0 5px;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        border-radius: 3px;
    }
    .custom-field {
        font-size: 14px !important;
        color: rgb(22, 58, 219) !important;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
</style> 
